import { Link } from '~/ui-components/Link';
import { forwardRef } from 'react';
import { LinkProps as ChakraLinkProps } from '@chakra-ui/react';

type TabLinkProps = ChakraLinkProps & {
   href: string;
};

export const TabLink = forwardRef(function ({ href, children, ...chakraProps }: TabLinkProps, ref) {
   return (
      <Link href={href} style={{ textDecoration: 'none' }}>
         {children}
      </Link>
   );
});
